import { NavMenu } from '../NavMenu'
import { useAuth } from 'context/authentication/useAuth'
import * as S from './styles'
import logo from '../../../assets/logo.svg'
import { NotificationButton } from 'components/Notification/NotificationButton'

export function AuthenticatedNav() {
  const { logout, user } = useAuth()

  return (
    <S.Wrapper>
      <S.LogoImg src={logo} alt="logo" />
      <NavMenu
        items={[
          { label: 'Dashboard', to: '/dashboard' },
          { label: 'Activity', to: '/activity' },
          { label: 'Contacts', to: '/contacts' },
          { label: 'Opportunities', to: '/opportunities' },
          { label: 'Deals', to: '/deals' },
          { label: 'Product', to: '/product' },
          { label: 'Settings', to: '/settings' },
        ]}
      />

      <NotificationButton />

      <S.CompanyTitle>@{user?.email.split('@')[1]}</S.CompanyTitle>

      <S.LogoutIcon onClick={logout} style={{ marginRight: 20 }} />
    </S.Wrapper>
  )
}
